import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { pdpUrlFilters, getFilterProps } from "./helper";
import { IconLink } from "../../../../utils/icons";

// Has / has no PDP URL (URL key `hasPdp`) — matches the card's PDP chip.
interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

export const PdpUrlFilter: FC<Props> = ({ onFilterSelect, ...rest }) => (
  <SingleFilter
    {...rest}
    {...getFilterProps(pdpUrlFilters, "hasPdp")}
    title="PDP URL"
    updateSearch={onFilterSelect}
    icon={IconLink}
  />
);
